import { FC, Suspense, useEffect } from 'react';
import { AuthorizedPage, getBase, TenantLayout, Themes, useThemeContext } from '@maxtropy/components';
import { Outlet } from 'react-router-dom';
import { ScadaProvider } from '@maxtropy/scada';

// scada路由出口
export const ScadaOutlet: FC = () => {
  const { setCustomTheme } = useThemeContext();

  useEffect(() => {
    setCustomTheme?.(Themes.DARK);
    return () => {
      setCustomTheme?.();
    };
  }, []);

  return (
    <Suspense fallback={null}>
      <AuthorizedPage>
        <ScadaProvider resourceBaseUrl="/scada-resources/storage/">
          <Outlet />
        </ScadaProvider>
      </AuthorizedPage>
    </Suspense>
  );
};

// 其他页面路由出口
export const MainOutlet: FC = () => {
  if (getBase()) {
    return (
      <Suspense fallback={null}>
        <Outlet />
      </Suspense>
    );
  }

  return (
    <Suspense fallback={null}>
      <AuthorizedPage>
        <TenantLayout>
          <Outlet />
        </TenantLayout>
      </AuthorizedPage>
    </Suspense>
  );
};
